if (
  window.THREE &&
  !THREE.WebGLRenderer.prototype.getMaxAnisotropy
) {
  THREE.WebGLRenderer.prototype.getMaxAnisotropy = function () {
    return this.capabilities.getMaxAnisotropy();
  };
}

function initializeRippleImages(root = document) {
  root.querySelectorAll(".js-ripple-image").forEach((parent) => {
    if (parent.dataset.rippleInitialized === "true") {
      return;
    }

    const image = parent.querySelector(".js-ripple-image img");

    if (!image) {
      return;
    }

    const initialize = () => {
      const texture = image.currentSrc || image.src;

      if (!texture) {
        return;
      }

      const effect = new RippleEffect({
        parent,
        texture,
        intensity: 1,
        strength: 2,
        area: 6,
        waveSpeed: 0.012,
        speedIn: 1,
        speedOut: 3,
        easing: "quad",
        hover: false
      });

      let stopTimer;

      parent.addEventListener("mouseenter", () => {
        window.clearTimeout(stopTimer);
        effect.start();

        stopTimer = window.setTimeout(() => {
          effect.stop();
        }, 1000);
      });

      parent.addEventListener("mouseleave", () => {
        window.clearTimeout(stopTimer);
        effect.stop();
      });

      parent.dataset.rippleInitialized = "true";
    };

    if (image.complete && image.naturalWidth > 0) {
      initialize();
    } else {
      image.addEventListener("load", initialize, { once: true });
    }
  });
}

function startRippleImages() {
  initializeRippleImages();

  document.addEventListener("shopify:section:load", (event) => {
    initializeRippleImages(event.target);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startRippleImages);
} else {
  startRippleImages();
}